import React, { useState } from 'react'

import './index.scss'
import Select, { OnChangeValue } from 'react-select'
import clsx from 'clsx'

export interface SelectComponentProps {
    clearSelect?: any
    isSearchable?: boolean
    options?: SelectOption[]
    isDisabled?: boolean
    isMenuPlacementTop?: boolean
    selectedValue?: SelectOption | null
    defaultValue?: SelectOption | null
    onValueChange?(value: SelectOption | null): void
    activeInputState?: boolean
    placeholder?: string
    isClearable?: boolean
    name?: string
}

export interface SelectOption {
    label: string
    value: string
    id: string
}

const SelectComponent = ({
    isSearchable,
    options,
    defaultValue,
    selectedValue,
    isDisabled,
    isMenuPlacementTop,
    activeInputState,
    isClearable,
    placeholder,
    name,
    onValueChange,
}: SelectComponentProps) => {
    const [menuIsOpen, setMenuIsOpen] = useState(false)

    const onMenuOpen = () => setMenuIsOpen(true)

    const onMenuClose = () => setMenuIsOpen(false)

    const handleValueChange = (newValue: OnChangeValue<SelectOption, false>) => {
        if (onValueChange) {
            onValueChange(newValue)
        }
    }

    const classNames = clsx(
        'select-component',
        menuIsOpen && 'focus',
        activeInputState && 'active-search',
        isDisabled && 'disabled'
    )
    let components
    if (isDisabled) {
        components = { DropdownIndicator: () => null, IndicatorSeparator: () => null }
    }

    return (
        <div className={classNames}>
            <Select
                name={name}
                inputId={name}
                isSearchable={!!isSearchable}
                classNamePrefix="react-select"
                onMenuOpen={onMenuOpen}
                onMenuClose={onMenuClose}
                onChange={handleValueChange}
                options={options}
                defaultValue={defaultValue}
                menuIsOpen={menuIsOpen}
                value={selectedValue}
                isDisabled={isDisabled}
                isClearable={isClearable}
                menuPlacement={isMenuPlacementTop ? 'top' : 'auto'}
                placeholder={placeholder}
                components={components}
            />
        </div>
    )
}

export default SelectComponent
